( function () {
	'use strict';

	function ManageShareCtrl ( $q, manageShareService, logger, TOOLTIP_MESSAGES, ERROR_MSGS, $filter ) {
		var self = this;

		self.itemsPerPage    = 10;
		self.currentPage     = 1;
		self.maxSize         = 10;
		self.tooltipMessages = TOOLTIP_MESSAGES;

		var type = {
			'district' : 'hierarchy',
			'school'   : 'hierarchy',
			'user'     : 'users'
		};

		var inherited = {
			'result' : true
		};

		var action = {
			'add'   : true,
			'block' : false
		};

		var apiType = {
			'remove' : 'deletePrivilege',
			'add'    : 'updatePrivilege',
			'block'  : 'updatePrivilege'
		};

		function payload ( actionType, privilege ) {
			return {
				'privilege' : privilege,
				'allow'     : action[ actionType ]
			};
		}

		function changePrivilege ( actionType, privilege, id, modelType ) {
			var model   = type[ modelType ] || type[ self.modelType ];
			var load    = payload( actionType, privilege );
			var callAPI = apiType[ actionType ];

			manageShareService[ callAPI ]( self.templateId, model, id, load )
			.then( function () {
				logger.info( 'Sucessfully saved privilege!' );
			}, function () {
				logger.info( ERROR_MSGS.manageShareSubmittingError );
			} );
		}

		function toNumeric ( privilege ) {
			if ( angular.isUndefined( privilege ) ) {
				return 0;
			}

			if ( privilege ) {
				return 1;
			}

			return 2;
		}

		function setParentifUndefined ( privilege, model ) {
			if ( angular.isUndefined( privilege ) && self.parentPriv ) {
				return self.parentPriv[ model ];
			}

			return toNumeric( privilege );
		}

		function getPriv ( model ) {
			model.privs     = {};
			var group       = type[ model.type ] || type[ self.modelType ];
			var id          = model.PersonnelId || model.ID || model.id;
			var inheritance = inherited[ self.modelType ] || false;

			manageShareService.getPrivilege( self.templateId, group, id, inheritance )
				.then( function ( res ) {
					model.privs = {
						'admin'     : setParentifUndefined( res.admin, 'admin' ),
						'view'      : setParentifUndefined( res.view, 'view' ),
						'manage'    : setParentifUndefined( res.manage, 'manage' ),
						'inherited' : {
							'admin'  : angular.isUndefined( res.admin ),
							'view'   : angular.isUndefined( res.view ),
							'manage' : angular.isUndefined( res.manage )
						}
					};
				}, function () {
					logger.info( ERROR_MSGS.manageShareSubmittingError );
				} );
		}

		function fetchPrivilege () {
			var pageStart  = self.itemsPerPage * ( self.currentPage - 1 );
			var pageSize   = self.itemsPerPage;
			var collection = $filter( 'paging' )( self.collection, pageStart, pageSize );

			collection     = $filter( 'limitTo' )( collection, self.itemsPerPage );
			( collection || [] ).map( getPriv );
		}

		function activate () {
			logger.info( 'Activated Manage Share View' );
		}

		activate();

		self.changePrivilege = changePrivilege;
		self.fetchPrivilege  = fetchPrivilege;
	}

	angular
		.module( 'app.templates' )
		.controller( 'ManageShareCtrl', ManageShareCtrl );

	ManageShareCtrl.$inject = [ '$q', 'manageShareService', 'logger', 'TOOLTIP_MESSAGES', 'ERROR_MSGS', '$filter' ];
} )( );
